// Sets `--app-height` to the real visible viewport height in pixels.
//
// Older Android System WebViews (e.g. Chromium 91 on the Galaxy A70) don't bound
// <body> to `100vh`/`100dvh` reliably — body falls back to content height, which
// collapses the whole scroll-height chain (#root/main never get a viewport bound,
// so nothing scrolls and the overflow lands on the document). A concrete pixel
// height sidesteps every viewport-unit quirk. CSS consumes it via
// `var(--app-height, …)`, scoped to Android so iOS/desktop are untouched.

function setAppHeight() {
	const height = window.visualViewport?.height ?? window.innerHeight;
	if (height > 0) {
		document.documentElement.style.setProperty(
			"--app-height",
			`${Math.round(height)}px`,
		);
	}
}

export function initAppHeight() {
	setAppHeight();
	window.addEventListener("resize", setAppHeight);
	window.addEventListener("orientationchange", setAppHeight);
	window.visualViewport?.addEventListener("resize", setAppHeight);
}
